export default {"src":"/_next/static/media/build.65c02bd7.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};